<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12" >
        <v-btn min-width="10rem" style="text-transform: none" class="goto-btn warning" v-on:click="jobcanPc()">
          ジョブカンPC
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col cols="12" >
        <v-btn min-width="10rem" style="text-transform: none" class="goto-btn warning" v-on:click="jobcanMobile()">
          ジョブカンMobile
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col cols="12">
        <v-btn min-width="10rem" style="text-transform: none" class="goto-btn warning" v-on:click="gotoGitLab()">
          GitLab
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col cols="12">
        <v-btn min-width="10rem" style="text-transform: none" class="goto-btn warning" v-on:click="gotoRedmine()">
          Redmine
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col cols="12">
        <v-btn min-width="10rem" style="text-transform: none" class="goto-btn warning" v-on:click="gotoWebMail()">
          WebMail
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col cols="12">
        <v-btn min-width="10rem" style="text-transform: none" class="goto-btn warning" v-on:click="gotoTeams()">
          Teams
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col cols="12">
        <v-btn min-width="10rem" style="text-transform: none" class="goto-btn warning" v-on:click="gotoMicrosoft365()">
          Microsoft365
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col cols="12">
        <v-btn min-width="10rem" style="text-transform: none" class="goto-btn warning" v-on:click="gotoYayoiPayroll()">
          弥生給与next
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<style>
  .goto-btn {
    opacity:0.8;
  }
</style>

<script lang="ts">
  import Vue from 'vue'
  import { Component} from 'vue-property-decorator';

  @Component
  export default class Home extends Vue {
    // 初期データはインスタンスプロパティとして宣言できます
    message = 'Hello!'

    // コンポーネントメソッドはインスタンスメソッドとして宣言できます
    jobcanPc (): void {
      window.open("https://ssl.jobcan.jp/login/pc-employee-global?lang_code=ja")
    }
    jobcanMobile (): void {
      window.open("https://ssl.jobcan.jp/login/mb-employee?client_id=ejan&lang_code=ja")
    }

    gotoGitLab (): void {
      window.open("https://gitlab.ejan.work/", '_blank')
    }

    gotoRedmine (): void {
      window.open("https://redmine.ejan.work/", '_blank')
    }

    gotoWebMail (): void {
      // window.open("https://acmail6.secure.ne.jp/am_bin/amlogin", '_blank')
      window.open("https://rcmail.secure.ne.jp/", '_blank')
    }

    gotoTeams (): void {
      window.open("https://www.microsoft.com/ja-jp/microsoft-teams/log-in", '_blank')
    }

    gotoMicrosoft365 (): void {
      window.open("https://www.office.com/", '_blank')
    }

    gotoYayoiPayroll (): void {
      window.open('https://payroll-employee.yayoi-kk.co.jp/', '_blank')
    }
  }

  // export default Vue.extend({
  //   name: 'HelloWorld',
  // })
</script>
